import React, { useState, useMemo } from 'react'
import { useVehicles } from '../../../context/VehicleContext'
import FleetSummaryCards from './FleetSummaryCards'
import FleetOemReport from './FleetOemReport'
import CyberButton from './CyberButton'

const COMM_KEYS = new Set(['Communicating', 'Communicating but Vehicle Off / No Network'])
const NON_COMM_KEY = 'Non-Communicating'

const SAMenu = () => {
  const { vehicles, loading, error, lastUpdated, countdown, load } = useVehicles()
  const [cityFilter, setCityFilter] = useState('All cities')
  const [hubFilter, setHubFilter] = useState('All hubs')
  const [statusFilter, setStatusFilter] = useState('All')

  const cityOptions = useMemo(() => {
    const cities = Array.from(new Set(vehicles.map(v => v.mg?.city).filter(Boolean))).sort()
    return ['All cities', ...cities]
  }, [vehicles])

  const hubOptions = useMemo(() => {
    const source = cityFilter !== 'All cities'
      ? vehicles.filter(v => v.mg?.city === cityFilter)
      : vehicles
    const hubs = Array.from(new Set(source.map(v => v.mg?.depot_name).filter(Boolean))).sort()
    return ['All hubs', ...hubs]
  }, [vehicles, cityFilter])

  const handleCityChange = (city) => {
    setCityFilter(city)
    setHubFilter('All hubs')
  }

  const filtered = useMemo(() => {
    let result = vehicles
    if (cityFilter !== 'All cities') result = result.filter(v => v.mg?.city === cityFilter)
    if (hubFilter !== 'All hubs') result = result.filter(v => v.mg?.depot_name === hubFilter)
    if (statusFilter === 'Communicating') result = result.filter(v => COMM_KEYS.has(v.status))
    if (statusFilter === 'Non-Communicating') result = result.filter(v => v.status === NON_COMM_KEY)
    if (statusFilter === 'No API') result = result.filter(v => v.status === 'No API')
    if (statusFilter === '>12h Ignition Off') result = result.filter(v => v.status === 'More than 12 hours ignition off')
    return result
  }, [vehicles, cityFilter, hubFilter, statusFilter])

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'rgba(255,255,255,0.6)', fontSize: 15 }}>
        Loading fleet data…
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ padding: 24, color: '#fca5a5', fontSize: 14 }}>
        {error}
        <CyberButton onClick={load} style={{ marginLeft: 12 }}>Retry</CyberButton>
      </div>
    )
  }

  return (
    <div style={{ padding: '20px 24px', color: '#fff', minHeight: '100%' }}>

      {/* Header bar */}
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#fff', letterSpacing: 0.3 }}>Fleet Dashboard</h1>
        {lastUpdated && (
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.40)', marginTop: 3 }}>
            Last updated {lastUpdated.toLocaleTimeString()} · refresh in {countdown}s
          </div>
        )}
      </div>

      {/* Summary cards */}
      <FleetSummaryCards vehicles={filtered} />



      {/* OEM table */}
      <FleetOemReport
        vehicles={filtered}
        cityFilter={cityFilter} setCityFilter={handleCityChange} cityOptions={cityOptions}
        hubFilter={hubFilter} setHubFilter={setHubFilter} hubOptions={hubOptions}
        statusFilter={statusFilter} setStatusFilter={setStatusFilter}
      />

    </div>
  )
}

export default SAMenu
